import { atom } from "jotai";

import { currentBookingAtom } from "../stores";

export const getMemberRoundsAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return (
    booking?.rounds?.filter((r) => r.player?.clientType === "member") ?? []
  );
});
